import React from 'react';
import './Desclaimer.scss';

const Desclaimer = () => {
    return (
        <div className='mainPage'>
            <h2 className='textTitle text-uppercase fw-medium'>desclaimer</h2>
            <p>Most of us wonder if there is a God and if He really is the God of the Bible. In the Bible God says ‘I
                will make your name great’ and today the name of Abraham/Abram is known worldwide. This promise has come
                true. The earliest copy of Genesis found in the Dead Sea Scrolls is dated 200-100 B.C. which means the
                promise has been in writing since at least that time. At that time the name of Abraham was not
                well-known so the promise came true only after it was written down, not before.</p>
        </div>
    );
};

export default Desclaimer;
